import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=079180bd&scoped=true&"
import script from "./GettingStarted.vue?vue&type=script&lang=js&"
export * from "./GettingStarted.vue?vue&type=script&lang=js&"
import style0 from "./GettingStarted.vue?vue&type=style&index=0&id=079180bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079180bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079180bd')) {
      api.createRecord('079180bd', component.options)
    } else {
      api.reload('079180bd', component.options)
    }
    module.hot.accept("./GettingStarted.vue?vue&type=template&id=079180bd&scoped=true&", function () {
      api.rerender('079180bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Onboarding/GettingStarted.vue"
export default component.exports